import {
  defineComponent,
  ref,
  reactive,
  inject,
  onMounted,
  onBeforeUnmount,
  computed,
  toRefs,
  StyleValue,
  provide,
} from "vue";
import {
  FormInjectionKey,
  FormItemContext,
  FormItemInjectionKey,
} from "./const";
import { checkValue } from "./util";
import "./style/form-item.less";

export default defineComponent({
  name: "CFormItem",
  props: {
    /**
     * 表单项校验字段名
     */
    prop: String,
    /**
     * 表单项标题
     */
    label: String,
    /**
     * 表单项标题宽度
     */
    labelWidth: String,
  },
  setup(props, { slots }) {
    const form = inject(FormInjectionKey, undefined);
    const state = ref("init");
    const error = ref("");
    const { prop, label, labelWidth } = toRefs(props);
    const rules = computed(() => {
      return form && prop.value && form.rules
        ? form.rules[prop.value]
        : undefined;
    });
    const value = computed(() => {
      return form && prop.value && form.model
        ? form.model[prop.value]
        : undefined;
    });
    const formItemClass = computed(() => {
      const base = "c-form-item";
      return `${base} ${state.value === "error" ? " c-form-error" : ""}`;
    });
    const labelStyle = computed<StyleValue>(() => {
      let res: StyleValue = {};
      const width = labelWidth.value || form?.labelWidth;
      if (width) {
        res = typeof width === "number" ? { width: `${width}px` } : { width };
      }
      return res;
    });
    const required = computed(() => {
      const arr = rules.value;
      return !!arr && arr.length > 0 && arr.findIndex((r) => r.required) >= 0;
    });
    const validate = () => {
      let tip = "";
      const arr = rules.value;
      if (arr && arr.length > 0) {
        const val = value.value;
        tip = checkValue(arr, val);
      }
      if (tip) {
        state.value = "error";
      } else {
        state.value = "pass";
      }
      error.value = tip;
      return tip;
    };
    const checkPorp = (error?: boolean) => {
      if (!error || state.value === "error") {
        validate();
      }
    };
    provide(FormItemInjectionKey, reactive({ prop: prop.value, checkPorp }));
    const context: FormItemContext = reactive({
      prop: prop.value,
      validate,
    });
    onMounted(() => {
      form?.children.push(context);
    });
    onBeforeUnmount(() => {
      if (form) form.children = form?.children.filter((ctx) => ctx !== context);
    });
    return () => (
      <div class={formItemClass.value}>
        <div class="c-form-label" style={labelStyle.value} v-show={label.value}>
          {label.value}
          {required.value ? <span class="c-label-required">*</span> : null}
        </div>
        <div class="c-label-content">
          {slots?.default ? slots.default() : null}
          {error.value ? <div class="c-error-tip">{error.value}</div> : null}
        </div>
      </div>
    );
  },
});
